import { useEffect, useRef, useState } from "react";

const Whiteboard = ({ setDrawingState, setHasDrawing }) => {
  const canvasRef = useRef(null);
  const [drawing, setDrawing] = useState(false);
  const [path, setPath] = useState([]);

  useEffect(() => {
    const c = canvasRef.current;
    if (!c) return;
    const ctx = c.getContext("2d");
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, c.width, c.height);
  }, []);

  function getPoint(e) {
    const rect = canvasRef.current.getBoundingClientRect();
    return {
      x: e.clientX - rect.left,
      y: e.clientY - rect.top
    };
  }

  function start(e) {
    e.preventDefault();
    if (e.currentTarget?.setPointerCapture && e.pointerId != null) {
      e.currentTarget.setPointerCapture(e.pointerId);
    }
    setDrawing(true);
    const { x, y } = getPoint(e);
    setPath([[x, y]]);
  }

  function move(e) {
    e.preventDefault();
    if (!drawing) return;
    const { x, y } = getPoint(e);
    setPath(prev => {
      const n = prev.concat([[x, y]]);
      drawPath(n);
      return n;
    });
  }

  function end(e) {
    if (path.length < 3) {
      const c = canvasRef.current;
      const ctx = c.getContext("2d");
      ctx.clearRect(0, 0, c.width, c.height);
      setHasDrawing(false);
    } else {
      setHasDrawing(true);
    }
    setDrawing(false);
    setDrawingState(canvasRef.current);
  }

  function drawPath(points) {
    const c = canvasRef.current;
    const ctx = c.getContext("2d");
    ctx.clearRect(0, 0, c.width, c.height);
    ctx.fillStyle = "white";
    ctx.fillRect(0, 0, c.width, c.height);
    ctx.strokeStyle = "black";
    ctx.lineWidth = 2;
    if (!points || points.length === 0) return;
    ctx.beginPath();
    ctx.moveTo(points[0][0], points[0][1]);
    for (let p of points) ctx.lineTo(p[0], p[1]);
    ctx.stroke();
  }

  return (
    <div>
      <canvas
        ref={canvasRef}
        width={600}
        height={400}
        style={{ border: "1px solid #333", touchAction: "none" }}
        onPointerDown={start}
        onPointerMove={move}
        onPointerUp={end}
        onPointerLeave={end}
        onPointerCancel={end}
      />
    </div>
  )
}

export default Whiteboard;